import { action, makeObservable, observable } from "mobx";
import { ShopGoodImage } from "../../../interfaces";

export class ShopGoodImageStore implements ShopGoodImage {
	@observable id = 0;
	@observable shop_good_id = 0;
	@observable file = "";
	@observable is_cover = false;

	constructor(initialData: ShopGoodImage | null) {
		makeObservable(this);

		if (initialData) {
			this.fillStore(initialData);
		}
	}

	@action
	fillStore(data: ShopGoodImage) {
		const { id, shop_good_id, file, is_cover } = data;

		this.id = id;
		this.shop_good_id = shop_good_id;
		this.file = file;
		this.is_cover = is_cover;
	}
}
